<template>
  <div>
    <!-- TODO : Approval -->
    <normal-document
      ref="refNormalDocument"
      openType="popup"
      :propsBoardId="boardId"
      :tab="tab"
      :created="!readonly"
      :header="form.header"
      :docProjectId="projectId"
      :permission="permission"
      :usePrevPost="tab.usePrevPost"
      :prevPostButtonLabel="tab.prevPostButtonLabel"
      :use-print="false"
      :use-delete="false"
      :use-excel-download="false"
      :print-label="tab.printLabel"
      @board="setBoard"
      @move="onClickMoveList"
      @save="writeOnClickNormalSave"
    >
      <template #header="props">
        <div v-if="tab.useHeaderDate" class="h4 grid xl:flex gap-4" style="align-items: center">
          <div id="print-label">
            <p class="font-bold h4 flex" style="align-items: center">{{ tabItems[boardId].title || tab.label }}</p>
          </div>
          <div v-if="tab.headerDateType === 'date'" class="flex items-center">
            <date-selector class="mr-2" style="width: 140px" v-model="form.header.date" :readonly="readonly || !!postId" />
          </div>
          <div v-else-if="tab.headerDateType === 'year'" class="flex items-center">
            <vs-input
              type="number"
              class="ml-2"
              style="width: 100px"
              v-model="form.header.year"
              :readonly="readonly || !!postId"
              :min="2000"
              :max="new Date().getFullYear() + 100"
              @focusout="
                () => {
                  if (form.header.year < 2000) form.header.year = new Date().getFullYear();
                  if (form.header.year > new Date().getFullYear() + 100) form.header.year = new Date().getFullYear();
                }
              "
            />&nbsp;년
          </div>
          <div v-else class="flex items-center">
            <vs-input
              type="number"
              class="mr-2"
              style="width: 100px"
              v-model="form.header.year"
              :readonly="readonly || !!postId"
              :min="2000"
              :max="new Date().getFullYear() + 100"
              @focusout="
                () => {
                  if (form.header.year < 2000) form.header.year = new Date().getFullYear();
                  if (form.header.year > new Date().getFullYear() + 100) form.header.year = new Date().getFullYear();
                }
              "
            />년 <vs-input type="number" class="ml-4 mr-2" style="width: 100px" v-model="form.header.month" :readonly="readonly || !!postId" :min="1" :max="12" />월
          </div>
        </div>
        <!-- only title -->
        <div v-else id="print-label" class="h4 grid xl:flex gap-4" style="align-items: center">
          <p class="font-bold h4 flex" style="align-items: center">{{ tabItems[boardId].title || tab.label }}</p>
        </div>
      </template>
      <template #body="props">
        <component ref="normalDocumentComponent" :is="tabPageInfo.component" openType="popup" :tab="tab" :board="props.board" :header="form.header" :is-print="props.isPrint" :docProjectId="projectId" v-model="form.body" />
        <!--@saveButtonControl="(value) => writeSaveButtonControl(value)"-->
        <FileDownload v-if="!props.isPrint && tab.visibleFileDownload" :isChange="isAdmin" />
      </template>
    </normal-document>
  </div>
</template>

<script>
import NormalDocument from "@/views/write/document/NormalDocument.vue";

import tabItems from "@/views/boards/tab/tab-items";
import singlePageWrite from "@/views/boards/single-page/writeIndex";
import includeSinglePage from "@/views/boards/single-page/include";

export default {
  components: { NormalDocument },
  props: {
    isApproval: Boolean,
    readonly: Boolean,
    boardId: [Number, String],
    listTheme: String,
    nav: Object,
    method: Object,
    formOverwrite: Object, // 신규 문서를 작성할 때, 기본값을 덮어씌우기 위한 props
  },
  computed: {
    componentWrite() {
      return singlePageWrite[`${this.boardId}_write`];
    },
    heads() {
      if (singlePageList[`${this.boardId}_list`]) {
        return singlePageList[`${this.boardId}_list`].getHead();
      }
      return [];
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    postId() {
      return null;
    },
    singlePage() {
      const list = includeSinglePage.list;
      const write = includeSinglePage.write;
      const page = includeSinglePage.page;
      const excelupload = includeSinglePage.excelUpload;
      const exceluploadbulk = includeSinglePage.excelUploadBulk;
      return { list, write, page, "excel-upload": excelupload, "excel-upload-bulk": exceluploadbulk };
    },
    tabPageInfo() {
      const pageType = "write";
      const query = this.$route.query;
      const tabKey = `${this.boardId}_${pageType}`;
      const component = this.singlePage[pageType][tabKey.replaceAll("-", "")];
      const relatedPath = !pageType || pageType === "list" || pageType === "write" ? `/tab/${this.boardId}` : `/tab/${this.boardId}/${pageType}`;
      const tabItem = this.tabItems[this.boardId];
      return { pageType, query, tabKey, component, relatedPath, tabItem };
    },
  },
  watch: {
    nav(value) {
      this.popupNav = value;
    },
    formOverwrite(value) {
      console.log("value", value);
      if (value) {
        this.form = { ...this.form, ...value };
      }
      console.log("this.form", this.form);
    },
  },
  data() {
    return {
      tabItems,

      tab: {
        label: "수급업체 안전보건수준평가",
        isApproval: false,
        usePrint: false,
        useHeaderDate: true,
        headerDateType: "year",
        listTheme: "striped-table",
        tabKey: `${this.boardId}_list`,
        boardId: this.boardId,
        slug: `board-${this.boardId}`,
      },
      form: {
        parentsPostId: this.$route.params.postId,
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          date: new Date().format("yyyy-MM-dd"),
          half: new Date().getMonth() + 1 <= 6 ? "상반기" : "하반기", //반기
        },
        body: {},
      },
      permission: { c: 0, r: 0, u: 0, d: 0, v: 0 },
      isSaving: false, // 저장 중복 클릭 방지
      printDatas: [],
      isPrint: false,
      popupNav: {
        projectId: 0,
        orderTarget: "created_at",
        orderDirection: "desc",
        date: { year: new Date().getFullYear(), month: "" },
        value: {},
        page: {},
        keyword: [],
      },
    };
  },

  async created() {
    await this.loadPermission();
  },
  mounted() {
    this.$nextTick(() => {
      if (this.formOverwrite) {
        this.form = { ...this.form, ...this.formOverwrite };
      }
    });
  },
  methods: {
    setBoard(board) {
      this.board = board;
    },

    async loadPermission() {
      if (Number.isInteger(parseInt(this.boardId))) {
        let boards = this.$store.state.member.memberInfo.boards;
        if (!boards) {
          await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
          boards = this.$store.state.member.memberInfo.boards;
        }

        let board = boards.find((b) => parseInt(b.id) === parseInt(this.boardId));
        if (!!board && !!board.pivot) {
          if (board.pivot.project_id) {
            // 프로젝트에 맞는 권한이 있는지 다시 조사한다
            board = boards.find((b) => parseInt(b.pivot.board_id) === parseInt(this.boardId) && parseInt(b.pivot.project_id) === parseInt(this.projectId));
            this.permission = { ...board.pivot };
          } else {
            this.permission = { ...board.pivot };
          }
        }
      }
    },

    onClickMoveList() {
      this.$emit("movePage", "list");
    },

    async loadBoardPost(boardId, postId) {
      await this.$store.dispatch("board/LOAD_POST", {
        boardId,
        postId,
      });

      // 내용
      const post = this.$store.state.board.postInfo;
      this.docProjectId = post.project_id;

      if (post.post_content) {
        const form = JSON.parse(post.post_content);
        if (!form.body["fileList"]) {
          form.body.fileList = [];
        }
        if (!form.body["formList"]) {
          form.body.formList = [];
        }
        form.body.createdAt = post.created_at;

        this.printDatas.push(post);
      }
    },

    writeOnClickNormalSave() {
      this.writeSaveBoardPost("create");
      // if (this.postId) {
      //   this.writeSaveBoardPost("update");
      // } else {
      //   this.writeSaveBoardPost("create");
      // }
    },
    loading(open) {
      window.dispatchEvent(new CustomEvent("loadingDialog", { detail: { open } }));
    },
    async writeSaveBoardPost(type) {
      // 저장 요청 중 재진입 차단 (중복 생성 방지)
      if (this.isSaving) return;
      this.isSaving = true;
      this.loading(true);

      try {
        let normalDocument = this.$refs["normalDocumentComponent"];
        // 만약 normalDocument 값이 배열일 경우, 배열의 첫번째 값을 가져온다
        if (Array.isArray(normalDocument)) {
          normalDocument = normalDocument[0];
        }

        // 만약 normalDocument.validate 메서드가 존재하면 호출한다
        if (normalDocument.validate) {
          const validated = normalDocument.validate();
          // 검증 실패했으면 빠져나간다
          if (validated) {
            alert(validated);
            return;
          }
        }

        const form = this.form;
        form.header.full = `${form.header.year}-${form.header.month > 9 ? form.header.month : `0${form.header.month}`}-01`;

        const projectId = this.projectId;
        const boardId = this.boardId;
        const title = this.form.body.title;
        const content = JSON.stringify(form);

        if (type === "create") {
          const response = await this.$store.dispatch("board/CREATE_POST", {
            projectId,
            boardId,
            title,
            content,
          });
          if (response && response.message === "Created") this.$emit("successCreate");
        } else if (type === "update") {
          const postId = this.postId;
          await this.$store.dispatch("board/UPDATE_POST", {
            projectId,
            boardId,
            postId,
            title,
            content,
          });
        }
        this.writeOldForm = JSON.parse(JSON.stringify(this.form));
        this.onClickMoveList();
      } finally {
        this.isSaving = false;
        this.loading(false);
      }
    },
  },
};
</script>
